import { CustomSideState } from './customSide.types';

import { RootState } from '~/redux/store';

export const selectSelectedCustomSide = ({
  customSide,
}: RootState): CustomSideState['selectedCustomSide'] =>
  customSide.selectedCustomSide;
